import React from "react";
import styled, { css } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { CheckmarkCircleFill } from "@vitalsource/vstui-icons";
import FigureOrImage from "../../../apps/overleaf/components/figure-or-image";
import { getUid } from "../../../utils/uid";

const IMAGE_SPACING = 4;

const Styled = {
  FieldSet: styled.fieldset`
    border: 0;
    margin: 0;
    padding: 0;
  `,
  Legend: styled.legend`
    margin: 0;
    padding: 0 0 4px;
    float: left;
  `,
  ListContainer: styled.div`
    margin: -${IMAGE_SPACING}px;
    clear: both;
  `,
  List: styled.div`
    width: 100%;
  `,
  Radio: styled.input`
    &:not(:focus):not(:checked) + *:hover {
      box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px;
    }
    
    &:checked + * {
      box-shadow: 0 0 0 2px
        ${props => props.theme.vstui.color.primary.getShade(6)};
    }
  `,
  RadioLabel: styled.label`
    cursor: pointer;
    width: 100%;
    height: 100%;
    border: 1px solid ${cloud.getShade(4)};
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    color: white;

    &:before {
      display: none !important;
    }
  `,
  FigureContainer: styled.div`
    width: 99px;
    height: 99px;
    margin: ${IMAGE_SPACING}px;
    display: inline-block;
    position: relative;
  `,
  FigureStyles: css`
    width: 100%;
    height: 100%;
  `,
  FigureImageStyles: css`
    height: 100%;
    width: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
  CheckmarkHolder: styled.div`
    position: absolute;
    right: 6px;
    bottom: 6px;
    color: ${props => props.theme.vstui.color.primary.getShade(6)};
    background: white;
    border-radius: 40px;
    line-height: 0;
  `
};

export default class FigureBlock extends React.Component {
  baseId = getUid("FigureBlock");
  figuresByKey = {};

  constructor(props) {
    super(props);
    this.props.figures.map(f => (this.figuresByKey[f.figureId] = f));
  }

  // WARNING: Highly optimized for performance! Only view state
  // and selection expected to change
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      (nextProps.renderImages &&
        this.props.renderImages !== nextProps.renderImages) ||
      !!this.figuresByKey[nextProps.selectedFigure] ||
      !!(
        this.figuresByKey[this.props.selectedFigure] &&
        !this.figuresByKey[nextProps.selectedFigure]
      )
    );
  }

  getRadioId(figure) {
    return this.baseId + figure.cfi;
  }

  figureSelected(id) {
    this.props.onSelectFigure(id);
  }

  getMorePerformantFallback(fig) {
    if (!fig.title && !fig.caption) {
      return i18n.t("flashcards.images.description-unavailable")
    }
    return `${fig.title || ""} ${fig.caption || ""}`;
  }

  render() {
    return (
      <Styled.FieldSet innerRef={this.props.innerRef}>
        <Styled.Legend>{this.props.title}</Styled.Legend>
        <Styled.ListContainer>
          <Styled.List>
            {this.props.figures.map(f => (
              <Styled.FigureContainer key={f.figureId}>
                <Styled.Radio
                  type="radio"
                  name="figure-block-figure"
                  value={f.figureId}
                  id={this.getRadioId(f)}
                  checked={this.props.selectedFigure === f.figureId}
                  onChange={() => this.figureSelected(f.figureId)}
                />
                <Styled.RadioLabel htmlFor={this.getRadioId(f)}>
                  {this.props.renderImages ? (
                    <FigureOrImage
                      forceFigure
                      src={f.thumbnailURL}
                      src2x={f.thumbnailURL2x}
                      title={f.title}
                      caption={f.caption}
                      figureStyles={Styled.FigureStyles}
                      imageStyles={Styled.FigureImageStyles}
                    />
                  ) :
                    this.getMorePerformantFallback(f)
                  }
                </Styled.RadioLabel>
                {this.props.selectedFigure === f.figureId && (
                  <Styled.CheckmarkHolder>
                    <CheckmarkCircleFill />
                  </Styled.CheckmarkHolder>
                )}
              </Styled.FigureContainer>
            ))}
          </Styled.List>
        </Styled.ListContainer>
      </Styled.FieldSet>
    );
  }
}
